module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Loan Amounts"},"fr":{"title":"Montants du prêt"}}')
  delete Component.options._Ctor
}
